import React from "react";
import Heading from "../../components/Heading";
import SubHeading from "../../components/SubHeading";

const BlogTestimonoals = () => {
  return (
    <section classname="text-neutral-700 dark:text-neutral-300 py-[3%]">
      <div classname="mx-auto text-center md:max-w-xl lg:max-w-3xl">
        <Heading content="testimonies" />
        <SubHeading SubHeading="loream Grow leads for your business by using recommended SEO strategies that will help your audience discover your website more easily." />
      </div>

      <div classname="grid gap-6 text-center md:grid-cols-3 py-[2%] md:mx-[10%]">
        <div>
          <div classname="block rounded-lg bg-white shadow-lg dark:bg-neutral-700 dark:shadow-black/30">
            <div classname="h-28 overflow-hidden rounded-t-lg bg-[#9d789b]"></div>
            <div classname="mx-auto -mt-12 w-24 overflow-hidden rounded-full border-2 border-white bg-white dark:border-neutral-800 dark:bg-neutral-800">
              <img
                src="https://tecdn.b-cdn.net/img/Photos/Avatars/img%20(1).webp"
                alt=""
              />
            </div>
            <div classname="p-6">
              <h4 classname="mb-4 text-2xl font-bold text-black">Maria Smantha</h4>
              <hr />
              <p classname="mt-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  classname="inline-block h-7 w-7 pr-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M13 14.725c0-5.141 3.892-10.519 10-11.725l.984 2.126c-2.215.835-4.163 3.742-4.38 5.746 2.491.392 4.396 2.547 4.396 5.149 0 3.182-2.584 4.979-5.199 4.979-3.015 0-5.801-2.305-5.801-6.275zm-13 0c0-5.141 3.892-10.519 10-11.725l.984 2.126c-2.215.835-4.163 3.742-4.38 5.746 2.491.392 4.396 2.547 4.396 5.149 0 3.182-2.584 4.979-5.199 4.979-3.015 0-5.801-2.305-5.801-6.275z" />
                </svg>
                Lorem ipsum dolor sit amet eos adipisci, consectetur adipisicing
                elit.
              </p>
            </div>
          </div>
        </div>
        <div>
          <div classname="block rounded-lg bg-white shadow-lg dark:bg-neutral-700 dark:shadow-black/30">
            <div classname="h-28 overflow-hidden rounded-t-lg bg-[#7a81a8]"></div>
            <div classname="mx-auto -mt-12 w-24 overflow-hidden rounded-full border-2 border-white bg-white dark:border-neutral-800 dark:bg-neutral-800">
              <img
                src="https://tecdn.b-cdn.net/img/Photos/Avatars/img%20(2).webp"
                alt=""
              />
            </div>
            <div classname="p-6">
              <h4 classname="mb-4 text-2xl text-black font-bold">Lisa Cudrow</h4>
              <hr />
              <p classname="mt-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  classname="inline-block h-7 w-7 pr-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M13 14.725c0-5.141 3.892-10.519 10-11.725l.984 2.126c-2.215.835-4.163 3.742-4.38 5.746 2.491.392 4.396 2.547 4.396 5.149 0 3.182-2.584 4.979-5.199 4.979-3.015 0-5.801-2.305-5.801-6.275zm-13 0c0-5.141 3.892-10.519 10-11.725l.984 2.126c-2.215.835-4.163 3.742-4.38 5.746 2.491.392 4.396 2.547 4.396 5.149 0 3.182-2.584 4.979-5.199 4.979-3.015 0-5.801-2.305-5.801-6.275z" />
                </svg>
                Neque cupiditate assumenda in maiores repudi mollitia
                architecto.
              </p>
            </div>
          </div>
        </div>
        <div>
          <div classname="block rounded-lg bg-white shadow-lg dark:bg-neutral-700 dark:shadow-black/30">
            <div classname="h-28 overflow-hidden rounded-t-lg bg-[#6d5b98]"></div>
            <div classname="mx-auto -mt-12 w-24 overflow-hidden rounded-full border-2 border-white bg-white dark:border-neutral-800 dark:bg-neutral-800">
              <img
                src="https://tecdn.b-cdn.net/img/Photos/Avatars/img%20(9).webp"
                alt=""
              />
            </div>
            <div classname="p-6">
              <h4 classname="mb-4 text-2xl font-bold text-black">John Smith</h4>
              <hr />
              <p classname="mt-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  classname="inline-block h-7 w-7 pr-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M13 14.725c0-5.141 3.892-10.519 10-11.725l.984 2.126c-2.215.835-4.163 3.742-4.38 5.746 2.491.392 4.396 2.547 4.396 5.149 0 3.182-2.584 4.979-5.199 4.979-3.015 0-5.801-2.305-5.801-6.275zm-13 0c0-5.141 3.892-10.519 10-11.725l.984 2.126c-2.215.835-4.163 3.742-4.38 5.746 2.491.392 4.396 2.547 4.396 5.149 0 3.182-2.584 4.979-5.199 4.979-3.015 0-5.801-2.305-5.801-6.275z" />
                </svg>
                Delectus impedit saepe officiis ab aliquam repellat rem unde
                ducimus.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogTestimonoals;
